import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  Tabs,
  Tab,
  TextField,
  Button,
  Divider,
  IconButton,
  Snackbar,
  CircularProgress,
  Pagination,
  Step,
  Stepper,
  StepLabel,
  Container,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Modal,
  Skeleton,
  Tooltip,
} from "@mui/material";
import { useSelector } from "react-redux";
import CandidateCard from "./CandidateCard";
import { useState } from "react";
import CandidatePagination from "./CandidatePagination";
import { getApplicants } from "../../../../Redux/Reducers/JobReducer";
import { useDispatch } from "react-redux";

const ApplicantsViewPage = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const applicantsData = useSelector((state) => state?.jobs.applicants);
  const applicants = applicantsData;
  const TotalPages = applicantsData?.pagination;
  // console.log("applicantsview", applicantsData)

  const handlePage = (count) => {
    setPage(count);
    dispatch(
      getApplicants({
        job_id: applicants?.[0]?.Job_id,
        page: count,
      })
    );
  };

  return (
    <Card
      sx={{
        width: "30%",
        padding: "10px",
        boxShadow:
          "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
      }}
    >
      <CardContent
        sx={{
          height: "80vh",
          overflowY: "auto",
          padding: "10px",
          scrollbarWidth: "none",
          flexWrap: "wrap",
        }}
      >
        <Box
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          // grid="repeat(2, 1fr)"
          gap={2}
          sx={{
            width: "100%",
          }}
        >
          {applicants?.length > 0 ? (
            applicants?.map((candidate, index) => (
              <CandidateCard candidate={candidate} />
            ))
          ) : (
            <Typography color="black">No candidates found</Typography>
          )}
        </Box>
      </CardContent>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <CandidatePagination
          totalPages={TotalPages?.totalPages}
          currentPage={page}
          onPageChange={handlePage}
        />
      </Box>
    </Card>
  );
};

export default ApplicantsViewPage;
